/* eslint angular/file-name:off */
(function() {
    'use strict';
    angular.module('emarket.main.profile', [ 'ui.router' ]).config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('main.profile', {
                url: '/perfil',
                abstract: true,
                views: {
                    main: {
                        templateUrl: 'main/profile/profile.tpl.html',
                        controller: 'ProfileController as model'
                    }
                },

                data: {
                    hideBanner: '728x90'
                }
            })
            .state('main.profile.edit', {
                url: '/editar',
                views: {
                    profile: {
                        templateUrl: 'main/profile/edit/profile-edit.tpl.html',
                        controller: 'ProfileEditController as vm'
                    }
                }
            })
            .state('main.profile.edit.phone', {
                url: '/telefono',
                views: {
                    'profile@main.profile': {
                        templateUrl: 'main/profile/edit/profile.edit.phone.tpl.html',
                        controller: 'ProfileEditPhoneController as vm'
                    }
                }
            })
            .state('main.profileDetail', {
                url: '/perfil/detalle/:user',
                views: {
                    main: {
                        templateUrl: 'main/profile/detail/detail.tpl.html',
                        controler: 'ProfileDetailController as model'
                    }
                }
            })
            .state('main.profile.menu', {
                url: '/',
                resolve: {
                    status: ['$mdMedia', '$state', '$timeout', function($mdMedia, $state, $timeout) {
                        if (!$mdMedia('xs') && !$mdMedia('sm')) {
                            $timeout(function() {
                                $state.go('main.profile.products',
                                    {},
                                    {
                                        location: 'replace'
                                    });
                            }, 0);
                        }
                        return true;
                    }],
                    login: ['Auth', function(Auth) {
                        return Auth.requiredAuthentication();
                    }]
                },
                views: {
                    profile: {
                        templateUrl: 'main/profile/menu/menu.tpl.html',
                        controller: 'ProfileMenuController as model'
                    }
                }
            })
            .state('main.profile.products', {
                url: '/productos?editar',
                views: {
                    profile: {
                        templateUrl: 'main/profile/products/products.tpl.html',
                        controller: 'ProfileProductsController as model'
                    }
                }
            })
            .state('main.profile.chat', {
                url: '/chat',
                views: {
                    profile: {
                        templateUrl: 'main/profile/chat/chat.tpl.html',
                        controller: 'ChatController as model'
                    }
                },
                data: {
                    hideFabAction: true
                }
            })
            .state('main.profile.favorite', {
                url: '/favoritos',
                abstract: true,
                views: {
                    profile: {
                        templateUrl: 'main/profile/favorites/favorite.tpl.html'
                    }
                }
            })
            .state('main.profile.favorite.lis̀t', {
                url: '/',
                views: {
                    favorite: {
                        templateUrl: 'main/profile/favorites/list.tpl.html',
                        controller: 'FavoriteController as model'
                    }
                },
                params: {
                    type: 'post'
                },
                onEnter: ['$state', '$mdMedia', function($state, $mdMedia) {
                    if (!$mdMedia('xs') && !$mdMedia('sm')) {
                        $state.go('main.profile.favorite.post');
                    }
                }]
            })
            .state('main.profile.favorite.post', {
                url: '/productos',
                views: {
                    favorite: {
                        templateUrl: 'main/profile/favorites/post.tpl.html',
                        controller: 'FavoriteController as model'
                    }
                },
                params: {
                    type: 'post'
                },
                onEnter: ['$state', '$mdMedia', function($state, $mdMedia) {
                    if ($mdMedia('xs') || $mdMedia('sm')) {
                        $state.go('main.profile.favorite.list');
                    }
                }]
            })
            .state('main.profile.favorite.seller', {
                url: '/tiendas',
                views: {
                    favorite: {
                        templateUrl: 'main/profile/favorites/seller.tpl.html',
                        controller: 'FavoriteController as model'
                    }
                },
                params: {
                    type: 'seller'
                },
                onEnter: ['$state', '$mdMedia', function($state, $mdMedia) {
                    if ($mdMedia('xs') || $mdMedia('sm')) {
                        $state.go('main.profile.favorite.list');
                    }
                }]
            })
            .state('main.profile.chat.detail', {
                url: '/:id',
                views: {
                    chat: {
                        templateUrl: 'main/profile/chat/chat-detail.tpl.html',
                        controller: 'ChatDetailController as model'
                    }
                },
                params: {
                    chat: null
                }
            })
            .state('main.profile.transaction', {
                url: '/transaccion',
                views: {
                    profile: {
                        templateUrl: 'main/profile/transaction/transaction.tpl.html',
                        controller: 'TransactionController as vm'
                    }
                }
            });
    }]);
}());

/* eslint angular/file-name:off */
(function() {
    'use strict';
    angular.module('emarket.main.profile', [ 'ui.router' ]).config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('main.profile', {
                url: '/perfil',
                abstract: true,
                views: {
                    main: {
                        templateUrl: 'main/profile/profile.tpl.html',
                        controller: 'ProfileController as model'
                    }
                },

                data: {
                    hideBanner: '728x90'
                }
            })
            .state('main.profile.edit', {
                url: '/editar',
                views: {
                    profile: {
                        templateUrl: 'main/profile/edit/profile-edit.tpl.html',
                        controller: 'ProfileEditController as vm'
                    }
                }
            })
            .state('main.profile.edit.phone', {
                url: '/telefono',
                views: {
                    'profile@main.profile': {
                        templateUrl: 'main/profile/edit/profile.edit.phone.tpl.html',
                        controller: 'ProfileEditPhoneController as vm'
                    }
                }
            })
            .state('main.profileDetail', {
                url: '/perfil/detalle/:user',
                views: {
                    main: {
                        templateUrl: 'main/profile/detail/detail.tpl.html',
                        controler: 'ProfileDetailController as model'
                    }
                }
            })
            .state('main.profile.menu', {
                url: '/',
                resolve: {
                    status: ['$mdMedia', '$state', '$timeout', function($mdMedia, $state, $timeout) {
                        if (!$mdMedia('xs') && !$mdMedia('sm')) {
                            $timeout(function() {
                                $state.go('main.profile.products',
                                    {},
                                    {
                                        location: 'replace'
                                    });
                            }, 0);
                        }
                        return true;
                    }],
                    login: ['Auth', function(Auth) {
                        return Auth.requiredAuthentication();
                    }]
                },
                views: {
                    profile: {
                        templateUrl: 'main/profile/menu/menu.tpl.html',
                        controller: 'ProfileMenuController as model'
                    }
                }
            })
            .state('main.profile.products', {
                url: '/productos?editar',
                views: {
                    profile: {
                        templateUrl: 'main/profile/products/products.tpl.html',
                        controller: 'ProfileProductsController as model'
                    }
                }
            })
            .state('main.profile.chat', {
                url: '/chat',
                views: {
                    profile: {
                        templateUrl: 'main/profile/chat/chat.tpl.html',
                        controller: 'ChatController as model'
                    }
                },
                data: {
                    hideFabAction: true
                }
            })
            .state('main.profile.favorite', {
                url: '/favoritos',
                abstract: true,
                views: {
                    profile: {
                        templateUrl: 'main/profile/favorites/favorite.tpl.html'
                    }
                }
            })
            .state('main.profile.favorite.lis̀t', {
                url: '/',
                views: {
                    favorite: {
                        templateUrl: 'main/profile/favorites/list.tpl.html',
                        controller: 'FavoriteController as model'
                    }
                },
                params: {
                    type: 'post'
                },
                onEnter: ['$state', '$mdMedia', function($state, $mdMedia) {
                    if (!$mdMedia('xs') && !$mdMedia('sm')) {
                        $state.go('main.profile.favorite.post');
                    }
                }]
            })
            .state('main.profile.favorite.post', {
                url: '/productos',
                views: {
                    favorite: {
                        templateUrl: 'main/profile/favorites/post.tpl.html',
                        controller: 'FavoriteController as model'
                    }
                },
                params: {
                    type: 'post'
                },
                onEnter: ['$state', '$mdMedia', function($state, $mdMedia) {
                    if ($mdMedia('xs') || $mdMedia('sm')) {
                        $state.go('main.profile.favorite.list');
                    }
                }]
            })
            .state('main.profile.favorite.seller', {
                url: '/tiendas',
                views: {
                    favorite: {
                        templateUrl: 'main/profile/favorites/seller.tpl.html',
                        controller: 'FavoriteController as model'
                    }
                },
                params: {
                    type: 'seller'
                },
                onEnter: ['$state', '$mdMedia', function($state, $mdMedia) {
                    if ($mdMedia('xs') || $mdMedia('sm')) {
                        $state.go('main.profile.favorite.list');
                    }
                }]
            })
            .state('main.profile.chat.detail', {
                url: '/:id',
                views: {
                    chat: {
                        templateUrl: 'main/profile/chat/chat-detail.tpl.html',
                        controller: 'ChatDetailController as model'
                    }
                },
                params: {
                    chat: null
                }
            })
            .state('main.profile.transaction', {
                url: '/transaccion',
                views: {
                    profile: {
                        templateUrl: 'main/profile/transaction/transaction.tpl.html',
                        controller: 'TransactionController as vm'
                    }
                }
            });
    }]);
}());
